import script from "./WatchView.vue?vue&type=script&setup=true&lang=js"
export * from "./WatchView.vue?vue&type=script&setup=true&lang=js"

import "./WatchView.vue?vue&type=style&index=0&id=68e58c24&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68e58c24"]])

export default __exports__